var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.product.productLink},nativeOn:{"click":function($event){return _vm.viewProduct.apply(null, arguments)}}},[_vm._t("default",null,{"product":_vm.product,"displayLabels":_vm.displayLabels})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }